import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import ChecklistSalesEmail from '../components/checklist/ChecklistSalesEmail';

/**
 * Тестовая страница вёрстки email-отчёта sales-чек-листа (Figma 2332:6).
 * Без подключения к логике опроса и API — только UI preview.
 */
const ChecklistSalesEmailPreviewPage = () => (
  <div className="flex min-h-screen flex-col">
    <SEOHead
      title="Превью: email-отчёт чек-листа продаж | Антология"
      description="Тестовая вёрстка письма с результатами чек-листа готовности отдела продаж к Generative AI"
      canonical="https://antologia.tech/ready-for-ai-sales/email-preview"
      noindex
    />
    <Header />
    <main className="flex-1 bg-[#f5f5f7] px-4 py-10 sm:px-6 lg:px-8" style={{ paddingTop: '5rem' }}>
      <p className="mx-auto mb-6 max-w-[800px] text-center text-sm text-muted-foreground">
        Тестовая вёрстка email-отчёта по макету Figma. Логика и API не подключены.
      </p>
      <ChecklistSalesEmail />
    </main>
    <Footer />
  </div>
);

export default ChecklistSalesEmailPreviewPage;
